import { createReducer, on } from "@ngrx/store";
import { NavigationState, initialNavigationState } from "./navigation.state";
import { AllowUnload, ClearTriggerNavigation, SetCurrentRoute, SetDirtyForm, TriggerNavigation } from "./navigation.actions";

export const NavigationReducers = createReducer(
    initialNavigationState,
    on(SetDirtyForm, (state, action): NavigationState => {
        return {
            ...state,
            hasDirtyForm: action.value,
            routeOnDirty: (action.value) ? state.previousRoute : null,
        };
    }),
    on(SetCurrentRoute, (state, action): NavigationState => {
        return {
            ...state,
            previousRoute: state.currentRoute,
            currentRoute: action.value
        };
    }),
    on(TriggerNavigation, (state): NavigationState => {
        return {
            ...state,
            trigger: true
        };
    }),
    on(ClearTriggerNavigation, (state): NavigationState => {
        return {
            ...state,
            trigger: false,
            routeOnDirty: null,
            hasDirtyForm: false
        };
    }),
    on(AllowUnload, (state, action): NavigationState => {
        return {
            ...state,
            trigger: false,
            allowUnload: action.value
        };
    })
)